import * as React from 'react';
import { containerFactory, DefaultContainerProps } from 'app/infrastructure/redux';
import { actionCreators } from './actions';
import { Paper } from 'ui';
import { userSettingsTranslations } from './constants';
import { withPrompt, PromptProps } from 'app/components';
import { withSimpleForm } from 'app/infrastructure/simple-form';
import { SimpleFormProps } from 'app/infrastructure/simple-form/types';
import { ScrollToTop } from 'ui/scroll-to-top/scroll-to-top';
import { UserProfileHeading } from 'app/area/user-profile/user-profile-heading';
import { isExternalUserHandlingEnabled } from 'app/infrastructure/hosting';
import { UserProfileSectionHeading } from 'app/area/user-profile/user-profile-section-heading';
import { SettingsForm } from 'app/area/user-profile/settings/settings-form';
import { simpleFieldForPath } from 'app/infrastructure/simple-form';
import { STATE } from 'app/constants';

interface RouteParams {
  focus: string;
}

interface UserSettingsExternalProps {
  params: RouteParams;
}

export type ProfileContainerProps = UserSettingsExternalProps & typeof actionCreators
  & PromptProps & DefaultContainerProps & SimpleFormProps;

const SimpleForm = simpleFieldForPath(STATE.userSettings);

export class UserSettingsComponent extends React.Component<ProfileContainerProps> {

  public static statePath: string = STATE.userSettings;

  public render() {
    const { translation } = this.props;

    return <Paper componentId={'user-settings-paper'} className="user-profile-section-paper">
      <UserProfileHeading
        title={translation.main_title}
        veracityProfileLinkTitle={translation.edit_veracity_profile}
        showVeracityProfileLink={isExternalUserHandlingEnabled()} />
      <UserProfileSectionHeading sectionTitle={translation.sub_title} />
      <SettingsForm {...this.props} formComponent={SimpleForm} />
      <ScrollToTop />
    </Paper>;
  }
}

const selectors = {
  shouldPrompt: (state: any) =>
    !!state.simpleForm.editing?.hasChanges
};

const container = containerFactory(withPrompt(withSimpleForm(UserSettingsComponent)), actionCreators, selectors, userSettingsTranslations);

export { container as UserSettings };
